module.exports = __webpack_public_path__ + "img/Categories_bg_006.c7af4c64.jpg";